import { z } from 'zod';

export const RevokeExamCenterLocationPermissionFormSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { message: 'กรุณาระบุสาเหตุที่ยกเลิก' })
    .max(255, { message: 'ความยาวต้องไม่เกิน 255 ตัวอักษร' }),
});

export type RevokeExamCenterLocationPermissionFormInput = z.infer<
  typeof RevokeExamCenterLocationPermissionFormSchema
>;
